import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import { getInitialAppLanguage } from "./languagePreference";

const resources = {
  ru: {
    translation: {
      subject: "Математика",
      timer: "Осталось {{seconds}} секунд",
      playerHealth: "Здоровье {{name}}: {{hp}} из {{maxHp}}",
      botHealth: "Здоровье {{name}}: {{hp}} из {{maxHp}}",
      opponentName: "Ziyo",
      questionMultiply: "Сколько будет {{left}} умножить на {{right}}?",
      questionAdd: "Сколько будет {{left}} плюс {{right}}?",
      questionSubtract: "Сколько будет {{left}} минус {{right}}?",
      chooseAnswer: "Выберите ответ {{answer}}",
      chooseAllCorrect: "Можно выбрать несколько правильных ответов",
      confirmAnswers: "Ответить",
      specialAttack: "Особый удар",
      correct: "Верно! {{opponentName}} получает {{damage}} урона.",
      incorrect: "Попробуйте ещё раз. {{playerName}} получает {{damage}} урона.",
      battleAnswerError: "Не удалось проверить ответ. Попробуйте ещё раз.",
      arenaUnavailable: "3D-арена недоступна. Вопрос и бой продолжают работать.",
      battleArena: "Арена учебной битвы",
      victoryTitle: "Победа!",
      victoryBody: "{{playerName}}, знания принесли тебе победу!",
      defeatTitle: "Попробуем ещё!",
      defeatBody: "Новый бой — новый шанс ответить правильно.",
      playAgain: "Играть снова",
      rewardCalculating: "Подсчитываем награду…",
      coins: "монет",
      correctAnswers: "верных",
      levelUp: "Новый уровень {{level}}!",
      earnedUpgradePoints: "+{{count}} очко улучшения",
      audioControls: "Настройки звука",
      turnMusicOff: "Выключить музыку",
      turnMusicOn: "Включить музыку",
      turnEffectsOff: "Выключить звуки",
      turnEffectsOn: "Включить звуки",
      authMode: "Режим авторизации",
      authWelcome: "С возвращением, герой!",
      authCreateHero: "Создай своего героя",
      authLoginLead: "Войди — и продолжим учебную битву.",
      authRegisterLead: "Знания будут усиливать твоего персонажа.",
      authReturningWelcome: "С возвращением, {{name}}!",
      authReturningLead: "Нажми на своего героя и продолжи учебную битву.",
      authContinueAs: "Продолжить как {{name}}",
      authLoginWithCredentials: "Войти с логином",
      authCreateNewHero: "Создать нового героя",
      authLoginTab: "Вход",
      authRegisterTab: "Регистрация",
      authHeroName: "Имя героя",
      authHeroNamePlaceholder: "Введите имя героя",
      authEmail: "Электронная почта",
      authPhone: "Номер телефона",
      authPhoneHint: "Только для профиля — без SMS и подтверждения.",
      authPhoneInvalid: "Введите номер телефона в международном формате, например +998 90 123 45 67.",
      authPassword: "Пароль",
      authPasswordLength: "Пароль должен содержать минимум 8 символов.",
      authNameLength: "Имя героя должно содержать минимум 2 символа.",
      authLoginError: "Не удалось войти. Проверь почту и пароль.",
      authRegisterError: "Не удалось создать аккаунт. Попробуй ещё раз.",
      authEmailAlreadyRegistered: "Эта почта уже зарегистрирована. Перейди во вкладку «Вход».",
      authEmailNotConfirmed: "Сначала подтверди электронную почту.",
      authSignupDisabled: "Регистрация временно отключена. Попробуй позже.",
      authCheckEmail: "Проверь почту и подтверди регистрацию.",
      authLoading: "Загрузка…",
      authLoginAction: "Начать путь",
      authRegisterAction: "Создать героя",
      authLogout: "Выйти",
      authLogoutError: "Не удалось выйти. Попробуй ещё раз.",
      lobbyWelcome: "Добро пожаловать,",
      lobbyChooseHero: "Выбери героя",
      lobbyChooseSubject: "Выбери предмет",
      lobbyChooseLevel: "Выбери уровень",
      lobbyChooseCampaignLevel: "Выбери бой",
      campaignProgress: "Путь героя",
      campaignProgressValue: "{{current}} из {{total}}",
      campaignLevel: "Уровень {{level}}",
      campaignTier: "Ранг {{tier}}",
      campaignBoss: "Босс",
      campaignSwipeHint: "Листай уровни влево и вправо",
      campaignReplayTitle: "Повторить уровень {{level}}?",
      campaignReplayWarning: "За повторную победу ты получишь 5 монет без дополнительного XP.",
      campaignReplayCancel: "Назад",
      campaignReplayConfirm: "Повторить",
      campaignLevelUnlocked: "Открыт уровень {{level}}!",
      campaignComplete: "Все 20 уровней пройдены!",
      replayReward: "Награда за повтор: 5 монет",
      lobbyHeroStats: "{{hp}} HP · {{attack}} сила",
      lobbyCoins: "Монеты",
      heroLevel: "Уровень {{level}}",
      heroXp: "{{current}} из {{total}} XP",
      maxHeroLevel: "Максимальный уровень",
      winStreak: "Серия побед: {{count}}",
      nextReward: "До следующего очка улучшения: {{xp}} XP",
      upgradeHero: "Усилить героя",
      upgradePoints: "Очки улучшения",
      upgradeLevel: "Ул. {{level}}/10",
      upgrade_attack: "Удар",
      upgrade_vitality: "Здоровье",
      upgrade_crit: "Крит. шанс",
      upgrade_special: "Особая атака",
      lobbyUpgradeError: "Не удалось улучшить героя.",
      lobbySubject: "Предмет",
      lobbyLoadError: "Не удалось загрузить данные игры.",
      lobbyStartError: "Не удалось начать бой. Попробуй ещё раз.",
      lobbyStart: "Начать битву",
      lobbyStarting: "Готовим арену…",
      difficulty1: "Легко",
      difficulty2: "Средне",
      difficulty3: "Сложно",
      playerFallbackName: "Герой",
      backToLobby: "К выбору героя",
      battleExit: "Выйти из боя",
      battleExitTitle: "Выйти из боя?",
      battleExitWarning: "Весь прогресс в этой битве будет потерян.",
      battleStay: "Продолжить бой",
      battleExitConfirm: "Выйти",
      battleLeaving: "Выходим…",
      battleExitError: "Не удалось выйти из боя. Попробуй ещё раз."
    }
  },
  "uz-Latn": {
    translation: {
      subject: "Matematika",
      timer: "{{seconds}} soniya qoldi",
      playerHealth: "{{name}} joni: {{hp}} / {{maxHp}}",
      botHealth: "{{name}} joni: {{hp}} / {{maxHp}}",
      opponentName: "Ziyo",
      questionMultiply: "{{left}} ni {{right}} ga koʻpaytirsak nechchi?",
      questionAdd: "{{left}} ga {{right}} ni qoʻshsak nechchi?",
      questionSubtract: "{{left}} dan {{right}} ni ayirsak nechchi?",
      chooseAnswer: "{{answer}} javobini tanlash",
      chooseAllCorrect: "Bir nechta toʻgʻri javobni tanlash mumkin",
      confirmAnswers: "Javob berish",
      specialAttack: "Maxsus zarba",
      correct: "Toʻgʻri! {{opponentName}} {{damage}} zarar oldi.",
      incorrect: "Yana urinib koʻr. {{playerName}} {{damage}} zarar oldi.",
      battleAnswerError: "Javobni tekshirib boʻlmadi. Yana urinib koʻring.",
      arenaUnavailable: "3D maydon ishlamayapti. Savol va jang davom etadi.",
      battleArena: "Taʼlim jangi maydoni",
      victoryTitle: "Gʻalaba!",
      victoryBody: "{{playerName}}, bilimlaringiz gʻalaba keltirdi!",
      defeatTitle: "Yana urinib koʻramiz!",
      defeatBody: "Yangi jang — toʻgʻri javob uchun yangi imkoniyat.",
      playAgain: "Qayta oʻynash",
      rewardCalculating: "Mukofot hisoblanmoqda…",
      coins: "tanga",
      correctAnswers: "toʻgʻri",
      levelUp: "Yangi {{level}}-daraja!",
      earnedUpgradePoints: "+{{count}} kuchaytirish ochkosi",
      audioControls: "Ovoz sozlamalari",
      turnMusicOff: "Musiqani oʻchirish",
      turnMusicOn: "Musiqani yoqish",
      turnEffectsOff: "Ovoz effektlarini oʻchirish",
      turnEffectsOn: "Ovoz effektlarini yoqish",
      authMode: "Kirish rejimi",
      authWelcome: "Qaytganing bilan, qahramon!",
      authCreateHero: "Qahramoningni yarat",
      authLoginLead: "Kiring — bilim jangini davom ettiramiz.",
      authRegisterLead: "Bilimlaring qahramoningni kuchaytiradi.",
      authReturningWelcome: "Qaytganing bilan, {{name}}!",
      authReturningLead: "Qahramoningizni bosing va bilim jangini davom ettiring.",
      authContinueAs: "{{name}} sifatida davom etish",
      authLoginWithCredentials: "Login bilan kirish",
      authCreateNewHero: "Yangi qahramon yaratish",
      authLoginTab: "Kirish",
      authRegisterTab: "Roʻyxatdan oʻtish",
      authHeroName: "Qahramon ismi",
      authHeroNamePlaceholder: "Qahramon ismini kiriting",
      authEmail: "Elektron pochta",
      authPhone: "Telefon raqami",
      authPhoneHint: "Faqat profil uchun — SMS va tasdiqlashsiz.",
      authPhoneInvalid: "Telefon raqamini xalqaro formatda kiriting, masalan +998 90 123 45 67.",
      authPassword: "Parol",
      authPasswordLength: "Parol kamida 8 ta belgidan iborat boʻlsin.",
      authNameLength: "Qahramon ismi kamida 2 ta belgidan iborat boʻlsin.",
      authLoginError: "Kirish amalga oshmadi. Pochta va parolni tekshiring.",
      authRegisterError: "Hisob yaratilmadi. Yana urinib koʻring.",
      authEmailAlreadyRegistered: "Bu pochta allaqachon roʻyxatdan oʻtgan. «Kirish» oynasiga oʻting.",
      authEmailNotConfirmed: "Avval elektron pochtangizni tasdiqlang.",
      authSignupDisabled: "Roʻyxatdan oʻtish vaqtincha oʻchirilgan. Keyinroq urinib koʻring.",
      authCheckEmail: "Pochtangizni tekshirib, roʻyxatdan oʻtishni tasdiqlang.",
      authLoading: "Yuklanmoqda…",
      authLoginAction: "Yoʻlni boshlash",
      authRegisterAction: "Qahramon yaratish",
      authLogout: "Chiqish",
      authLogoutError: "Chiqib boʻlmadi. Yana urinib koʻring.",
      lobbyWelcome: "Xush kelibsiz,",
      lobbyChooseHero: "Qahramonni tanlang",
      lobbyChooseSubject: "Fanni tanlang",
      lobbyChooseLevel: "Darajani tanlang",
      lobbyChooseCampaignLevel: "Jangni tanlang",
      campaignProgress: "Qahramon yo‘li",
      campaignProgressValue: "{{current}} / {{total}}",
      campaignLevel: "{{level}}-daraja",
      campaignTier: "{{tier}}-rang",
      campaignBoss: "Boshliq",
      campaignSwipeHint: "Darajalarni chapga va o‘ngga suring",
      campaignReplayTitle: "{{level}}-darajani takrorlaysizmi?",
      campaignReplayWarning: "Takroriy g‘alaba uchun qo‘shimcha XP siz 5 tanga olasiz.",
      campaignReplayCancel: "Orqaga",
      campaignReplayConfirm: "Takrorlash",
      campaignLevelUnlocked: "{{level}}-daraja ochildi!",
      campaignComplete: "Barcha 20 daraja tugallandi!",
      replayReward: "Takrorlash mukofoti: 5 tanga",
      lobbyHeroStats: "{{hp}} HP · {{attack}} kuch",
      lobbyCoins: "Tangalar",
      heroLevel: "{{level}}-daraja",
      heroXp: "{{current}} / {{total}} XP",
      maxHeroLevel: "Eng yuqori daraja",
      winStreak: "Gʻalabalar seriyasi: {{count}}",
      nextReward: "Keyingi kuchaytirishgacha: {{xp}} XP",
      upgradeHero: "Qahramonni kuchaytirish",
      upgradePoints: "Kuchaytirish ochkolari",
      upgradeLevel: "{{level}}/10 daraja",
      upgrade_attack: "Zarba",
      upgrade_vitality: "Jon",
      upgrade_crit: "Krit. imkon",
      upgrade_special: "Maxsus hujum",
      lobbyUpgradeError: "Qahramonni kuchaytirib boʻlmadi.",
      lobbySubject: "Fan",
      lobbyLoadError: "Oʻyin maʼlumotlarini yuklab boʻlmadi.",
      lobbyStartError: "Jangni boshlab boʻlmadi. Yana urinib koʻring.",
      lobbyStart: "Jangni boshlash",
      lobbyStarting: "Maydon tayyorlanmoqda…",
      difficulty1: "Oson",
      difficulty2: "Oʻrta",
      difficulty3: "Qiyin",
      playerFallbackName: "Qahramon",
      backToLobby: "Qahramon tanlashga",
      battleExit: "Jangdan chiqish",
      battleExitTitle: "Jangdan chiqilsinmi?",
      battleExitWarning: "Ushbu jangdagi barcha natijalar yoʻqoladi.",
      battleStay: "Jangni davom ettirish",
      battleExitConfirm: "Chiqish",
      battleLeaving: "Chiqilmoqda…",
      battleExitError: "Jangdan chiqib boʻlmadi. Yana urinib koʻring."
    }
  }
} as const;

void i18n.use(initReactI18next).init({
  resources,
  lng: getInitialAppLanguage(),
  supportedLngs: ["ru", "uz-Latn"],
  fallbackLng: "ru",
  interpolation: { escapeValue: false }
});

export default i18n;
